<template>
  <div v-if="disabled" class="dropdown-container d-flex align-items-center">
    <div
      class="dropdown-button d-flex align-items-center drip-body-small arrow-icon disabled"
    >
      {{ $t('common.downloads') }}
    </div>
  </div>
  <b-nav-item-dropdown
    v-else
    right
    id="action-dropdown"
    class="dropdown-container d-flex align-items-center"
    toggle-class="dropdown-button d-flex align-items-center drip-body-small"
    menu-class="dropdown-options"
    boundary="window"
  >
    <template slot="button-content">
      {{ $t('common.downloads') }} &nbsp;
    </template>
    <b-dropdown-item
      v-for="(option, index) in optionList"
      :key="index"
      @click.prevent="fireEvent(option)"
      class="dropdown-option"
      active-class="opened"
    >
      {{ option && option.text }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    optionList() {
      return this.options
        .filter((option) => !option.disabled)
        .sort((a, b) => b.text.localeCompare(a.text))
    }
  },
  methods: {
    fireEvent(option) {
      this.$emit('fireEvent', option)
    }
  }
}
</script>
<style lang="scss">
.dropdown-container {
  &.show {
    .dropdown-button {
      background: $wealthy-green-50;
    }
  }
  .dropdown-button {
    cursor: pointer;
    user-select: none;
    outline: none;
    border-radius: 8px;
    font-size: 12px !important;
    font-weight: 700;
    color: $wealthy-green-500;
    padding: 12px 8px;
    &:hover {
      background: $wealthy-green-50;
    }
    .icon {
      color: $wealthy-green-500;
    }
    &.opened {
      background: $wealthy-green-50;
    }
    &.disabled {
      color: $disabled-grey;
      cursor: not-allowed;
      &:hover {
        background: $white;
      }
    }
  }
  .dropdown-options {
    border: 0px;
    background: $white;
    box-shadow: 0px 6px 12px 0px #0a2e5733;
    border-radius: 4px;
    padding: 4px 0px;
    a {
      padding: 4px 8px;
    }
    .dropdown-item:hover,
    .dropdown-item:focus {
      background: $sky-blue-50;
      color: $wealthy-green-600;
    }
    .dropdown-option {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: $noble-blue-500;
      margin: 3px 0px;
    }
  }
}
.arrow-icon::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
</style>
